import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import JournalNamesBody from './body.tsx';
import JournalNamesHeader from './header.tsx';
import { JournalNamesContextProvider } from '../../../contexts/journalNames/journalNames.tsx';

const JournalNames = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoggedIn)
            navigate("/login");
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn)
        return null;

    return (
        <JournalNamesContextProvider>
            <JournalNamesHeader />
            <JournalNamesBody />
        </JournalNamesContextProvider>
    );
};

export default JournalNames;
